/**
 * Ficheiros onde definimos regras de acesso a conteúdos em client side
 * https://medium.com/dailyjs/managing-user-permissions-in-your-react-app-a93a94ff9b40
 */
import { AbilityBuilder } from '@casl/ability'

/**
 * Defines how to detect object's type: https://stalniy.github.io/casl/abilities/2017/07/20/define-abilities.html
 */
function subjectName(item) {
    if (!item || typeof item === 'string') {
        return item
    }

    return item.__type
}

//can(['update', 'delete'], 'Todo', { assignee: 'me' }) exemplo de 3º parametro

export default AbilityBuilder.define({ subjectName }, can => {
    //********************************************* */
    //Row IDs Hidricas
    can(['viewIDsHidro'], [
        'UNGE-UTILIZADOR',
        'UNGE-ADMINISTRADOR',
        'CTCH-UTILIZADOR',
        'CTCH-ADMINISTRADOR',
        'CTCH-READER',
        'UNGE-SUPER ADMINISTRADOR'
    ])
    //Vista IDs Hidricas UNGE
    can(['viewIDsHidroUNGE'], [
        'UNGE-UTILIZADOR',
        'UNGE-ADMINISTRADOR',
        'UNGE-SUPER ADMINISTRADOR'
    ])
    //Vista IDs Hidricas PROD
    can(['viewIDsHidroPROD'], [
        'CTCH-UTILIZADOR',
        'CTCH-ADMINISTRADOR',
        'UNGE-SUPER ADMINISTRADOR'
    ])
    //Vista IDs Hidricas Historico
    can(['viewIDsHidroHist'], [
        'UNGE-UTILIZADOR',
        'UNGE-ADMINISTRADOR',
        'CTCH-UTILIZADOR',
        'CTCH-ADMINISTRADOR',
        'CTCH-READER',
        'UNGE-SUPER ADMINISTRADOR'
    ])
    //********************************************* */
    //Row IDs Termicas
    can(['viewIDsTerm'], [
        'UNGE-UTILIZADOR',
        'UNGE-ADMINISTRADOR',
        'SINES-UTILIZADOR',
        'SINES-ADMINISTRADOR',
        'SINES-READER',
        'RIBATEJO-UTILIZADOR',
        'RIBATEJO-ADMINISTRADOR',
        'RIBATEJO-READER',
        'LARES-UTILIZADOR',
        'LARES-ADMINISTRADOR',
        'LARES-READER',
        'EDPP_GLOBAL-READER',
        'UNGE-SUPER ADMINISTRADOR'
    ])
    //Vista IDs Termicas UNGE
    can(['viewIDsTermUNGE'], [
        'UNGE-UTILIZADOR',
        'UNGE-ADMINISTRADOR',
        'UNGE-SUPER ADMINISTRADOR'
    ])
    //Vista IDs Termicas PROD 
    can(['viewIDsTermPROD'], [
        'SINES-UTILIZADOR',
        'SINES-ADMINISTRADOR',
        'RIBATEJO-UTILIZADOR',
        'RIBATEJO-ADMINISTRADOR',
        'RIBATEJO-READER',
        'LARES-UTILIZADOR',
        'LARES-ADMINISTRADOR',
        'LARES-READER',
        'EDPP_GLOBAL-READER',
        'UNGE-SUPER ADMINISTRADOR'
    ])
    //Vista IDs Termicas Historico
    can(['viewIDsTermHist'], [
        'UNGE-UTILIZADOR',
        'UNGE-ADMINISTRADOR',
        'SINES-UTILIZADOR',
        'SINES-ADMINISTRADOR',
        'SINES-READER',
        'RIBATEJO-UTILIZADOR',
        'RIBATEJO-ADMINISTRADOR',
        'RIBATEJO-READER',
        'LARES-UTILIZADOR',
        'LARES-ADMINISTRADOR',
        'LARES-READER',
        'EDPP_GLOBAL-READER',
        'UNGE-SUPER ADMINISTRADOR'
    ])
    //Manage IDs termicas from PROD side
    can(['manageIDsTerm'], [
        'RIBATEJO-UTILIZADOR',
        'RIBATEJO-ADMINISTRADOR',
        'LARES-UTILIZADOR',
        'LARES-ADMINISTRADOR',
        'UNGE-SUPER ADMINISTRADOR'
    ])
    //********************************************* */
    //Row Indisponilidades PTG
    can(['viewIndisps'], [
        'UNGE-UTILIZADOR',
        'UNGE-ADMINISTRADOR',
        'UNGE-INDISPS ADMIN',
        'UNGE-INDISPS UTLZ',
        'UNGE-READER',
        'CTCH-UTILIZADOR',
        'CTCH-ADMINISTRADOR',
        'CTCH-READER',
        'SINES-UTILIZADOR',
        'SINES-ADMINISTRADOR',
        'SINES-READER',
        'RIBATEJO-UTILIZADOR',
        'RIBATEJO-ADMINISTRADOR',
        'RIBATEJO-READER',
        'LARES-UTILIZADOR',
        'LARES-ADMINISTRADOR',
        'LARES-READER',
        'EDPP_GLOBAL-READER',
        'UNGE-SUPER ADMINISTRADOR'
    ])
    //Vista CIs
    can(['viewCIs'], [
        'UNGE-UTILIZADOR',
        'UNGE-ADMINISTRADOR',
        'UNGE-INDISPS ADMIN',
        'UNGE-INDISPS UTLZ',
        'UNGE-READER',
        'CTCH-UTILIZADOR',
        'CTCH-ADMINISTRADOR',
        'CTCH-READER',
        'SINES-UTILIZADOR',
        'SINES-ADMINISTRADOR',
        'SINES-READER',
        'RIBATEJO-UTILIZADOR',
        'RIBATEJO-ADMINISTRADOR',
        'RIBATEJO-READER',
        'LARES-UTILIZADOR',
        'LARES-ADMINISTRADOR',
        'LARES-READER',
        'EDPP_GLOBAL-READER',
        'UNGE-SUPER ADMINISTRADOR'
    ])
    //Create CIs
    can(['createCIs'], [
        'UNGE-INDISPS ADMIN',
        'CTCH-UTILIZADOR',
        'CTCH-ADMINISTRADOR',
        'RIBATEJO-UTILIZADOR',
        'RIBATEJO-ADMINISTRADOR',
        'LARES-UTILIZADOR',
        'LARES-ADMINISTRADOR',
        'UNGE-SUPER ADMINISTRADOR'
    ])
    //Edit CIs depending on the country and type
    can(['editCIs'], [
        'UNGE-INDISPS ADMIN-PTG-FT',
        'UNGE-INDISPS ADMIN-PTG-PL',
        'UNGE-INDISPS ADMIN-PTG-PG',
        'CTCH-UTILIZADOR-PTG-FT',
        'CTCH-UTILIZADOR-PTG-PL',
        'CTCH-UTILIZADOR-PTG-PG',
        'CTCH-ADMINISTRADOR-PTG-FT',
        'CTCH-ADMINISTRADOR-PTG-PL',
        'CTCH-ADMINISTRADOR-PTG-PG',
        'RIBATEJO-UTILIZADOR-PTG-FT',
        'RIBATEJO-UTILIZADOR-PTG-PL',
        'RIBATEJO-UTILIZADOR-PTG-PG',
        'RIBATEJO-ADMINISTRADOR-PTG-FT',
        'RIBATEJO-ADMINISTRADOR-PTG-PL',
        'RIBATEJO-ADMINISTRADOR-PTG-PG',
        'LARES-UTILIZADOR-PTG-FT',
        'LARES-UTILIZADOR-PTG-PL',
        'LARES-UTILIZADOR-PTG-PG',
        'LARES-ADMINISTRADOR-PTG-FT',
        'LARES-ADMINISTRADOR-PTG-PL',
        'LARES-ADMINISTRADOR-PTG-PG',
        'CTCH-ADMINISTRADOR-MNT-FT',
        'CTCH-UTILIZADOR-MNT-FT',
        'UNGE-SUPER ADMINISTRADOR-PTG-FT',
        'UNGE-SUPER ADMINISTRADOR-PTG-PL',
        'UNGE-SUPER ADMINISTRADOR-PTG-PG'
    ])
    //Import CIs by file
    can(['importCIsFile'], [
        'UNGE-INDISPS ADMIN-PTG',
        'CTCH-UTILIZADOR-PTG',
        'CTCH-ADMINISTRADOR-PTG',
        'UNGE-SUPER ADMINISTRADOR-PTG'
    ])
    //Accept CIs
    can(['acceptCIs'], [
        'UNGE-UTILIZADOR',
        'UNGE-ADMINISTRADOR',
        'UNGE-INDISPS ADMIN',
        'UNGE-INDISPS UTLZ',
        'UNGE-SUPER ADMINISTRADOR'
    ])
    //Vista FIs
    can(['viewFIs'], [
        'UNGE-UTILIZADOR',
        'UNGE-ADMINISTRADOR',
        'UNGE-INDISPS ADMIN',
        'UNGE-INDISPS UTLZ',
        'UNGE-READER',
        'UNGE-SUPER ADMINISTRADOR'
    ])
    //Editar FIs
    can(['handleFIs'], [
        'UNGE-UTILIZADOR',
        'UNGE-ADMINISTRADOR',
        'UNGE-INDISPS ADMIN',
        'UNGE-INDISPS UTLZ',
        'UNGE-SUPER ADMINISTRADOR'
    ])
    //Redireccionar para FIs
    can(['redirectFIs'], [
        'UNGE-UTILIZADOR',
        'UNGE-ADMINISTRADOR',
        'UNGE-INDISPS ADMIN',
        'UNGE-INDISPS UTLZ',
        'UNGE-READER',
        'UNGE-SUPER ADMINISTRADOR'
    ])
    //Não redireccionar para FIs
    can(['!redirectFIs'], [
        'CTCH-UTILIZADOR',
        'CTCH-ADMINISTRADOR',
        'CTCH-READER',
        'SINES-UTILIZADOR',
        'SINES-ADMINISTRADOR',
        'SINES-READER',
        'RIBATEJO-UTILIZADOR',
        'RIBATEJO-ADMINISTRADOR',
        'RIBATEJO-READER',
        'LARES-UTILIZADOR',
        'LARES-ADMINISTRADOR',
        'LARES-READER',
        'EDPP_GLOBAL-READER'
    ])
    //Vista IOs
    can(['viewIOs'], [
        'UNGE-UTILIZADOR',
        'UNGE-ADMINISTRADOR',
        'UNGE-INDISPS ADMIN',
        'UNGE-INDISPS UTLZ',
        'UNGE-READER',
        'CTCH-UTILIZADOR',
        'CTCH-ADMINISTRADOR',
        'CTCH-READER',
        'SINES-UTILIZADOR',
        'SINES-ADMINISTRADOR',
        'SINES-READER',
        'RIBATEJO-UTILIZADOR',
        'RIBATEJO-ADMINISTRADOR',
        'RIBATEJO-READER',
        'LARES-UTILIZADOR',
        'LARES-ADMINISTRADOR',
        'LARES-READER',
        'EDPP_GLOBAL-READER',
        'UNGE-SUPER ADMINISTRADOR'
    ])
    //Create IOs
    can(['createIOs'], [
        'UNGE-UTILIZADOR',
        'UNGE-ADMINISTRADOR',
        'UNGE-INDISPS ADMIN',
        'UNGE-SUPER ADMINISTRADOR'
    ])
    //Create IOs
    can(['acceptIOs'], [
        'UNGE-INDISPS ADMIN',
        'CTCH-UTILIZADOR',
        'CTCH-ADMINISTRADOR',
        'RIBATEJO-UTILIZADOR',
        'RIBATEJO-ADMINISTRADOR',
        'LARES-UTILIZADOR',
        'LARES-ADMINISTRADOR',
        'UNGE-SUPER ADMINISTRADOR'
    ])
    //********************************************* */
    //Row Condicionamentos PTG
    can(['viewConds'], [
        'UNGE-UTILIZADOR',
        'UNGE-ADMINISTRADOR',
        'UNGE-INDISPS ADMIN',
        'UNGE-INDISPS UTLZ',
        'UNGE-READER',
        'CTCH-UTILIZADOR',
        'CTCH-ADMINISTRADOR',
        'CTCH-READER',
        'SINES-UTILIZADOR',
        'SINES-ADMINISTRADOR',
        'SINES-READER',
        'RIBATEJO-UTILIZADOR',
        'RIBATEJO-ADMINISTRADOR',
        'RIBATEJO-READER',
        'LARES-UTILIZADOR',
        'LARES-ADMINISTRADOR',
        'LARES-READER',
        'EDPP_GLOBAL-READER',
        'UNGE-SUPER ADMINISTRADOR'
    ])
    //Vista CCs
    can(['viewCCs'], [
        'UNGE-UTILIZADOR',
        'UNGE-ADMINISTRADOR',
        'UNGE-INDISPS ADMIN',
        'UNGE-INDISPS UTLZ',
        'UNGE-READER',
        'CTCH-UTILIZADOR',
        'CTCH-ADMINISTRADOR',
        'CTCH-READER',
        'SINES-UTILIZADOR',
        'SINES-ADMINISTRADOR',
        'SINES-READER',
        'RIBATEJO-UTILIZADOR',
        'RIBATEJO-ADMINISTRADOR',
        'RIBATEJO-READER',
        'LARES-UTILIZADOR',
        'LARES-ADMINISTRADOR',
        'LARES-READER',
        'EDPP_GLOBAL-READER',
        'UNGE-SUPER ADMINISTRADOR'
    ])
    //Create CCs
    can(['createCCs'], [
        'UNGE-INDISPS ADMIN',
        'CTCH-UTILIZADOR',
        'CTCH-ADMINISTRADOR',
        'RIBATEJO-UTILIZADOR',
        'RIBATEJO-ADMINISTRADOR',
        'LARES-UTILIZADOR',
        'LARES-ADMINISTRADOR',
        'UNGE-SUPER ADMINISTRADOR'
    ])
     //Edit CCs depending on the country and type
     can(['editCCs'], [
        'UNGE-INDISPS ADMIN-PTG-FT',
        'UNGE-INDISPS ADMIN-PTG-PL',
        'UNGE-INDISPS ADMIN-PTG-PR',
        'UNGE-INDISPS ADMIN-PTG-OT',
        'CTCH-UTILIZADOR-PTG-FT',
        'CTCH-UTILIZADOR-PTG-PL',
        'CTCH-UTILIZADOR-PTG-PR',
        'CTCH-UTILIZADOR-PTG-OT',
        'CTCH-ADMINISTRADOR-PTG-FT',
        'CTCH-ADMINISTRADOR-PTG-PL',
        'CTCH-ADMINISTRADOR-PTG-PR',
        'CTCH-ADMINISTRADOR-PTG-OT',
        'RIBATEJO-UTILIZADOR-PTG-FT',
        'RIBATEJO-UTILIZADOR-PTG-PL',
        'RIBATEJO-UTILIZADOR-PTG-PR',
        'RIBATEJO-UTILIZADOR-PTG-OT',
        'RIBATEJO-ADMINISTRADOR-PTG-FT',
        'RIBATEJO-ADMINISTRADOR-PTG-PL',
        'RIBATEJO-ADMINISTRADOR-PTG-PR',
        'RIBATEJO-ADMINISTRADOR-PTG-OT',
        'LARES-UTILIZADOR-PTG-FT',
        'LARES-UTILIZADOR-PTG-PL',
        'LARES-UTILIZADOR-PTG-PR',
        'LARES-UTILIZADOR-PTG-OT',
        'LARES-ADMINISTRADOR-PTG-FT',
        'LARES-ADMINISTRADOR-PTG-PL',
        'LARES-ADMINISTRADOR-PTG-PR',
        'LARES-ADMINISTRADOR-PTG-OT',
        'CTCH-ADMINISTRADOR-MNT-FT',
        'CTCH-UTILIZADOR-MNT-FT',
        'UNGE-SUPER ADMINISTRADOR-PTG-FT',
        'UNGE-SUPER ADMINISTRADOR-PTG-PL',
        'UNGE-SUPER ADMINISTRADOR-PTG-PR',
        'UNGE-SUPER ADMINISTRADOR-PTG-OT'
    ])
    //Import CCs by file
    can(['importCCsFile'], [
        'UNGE-INDISPS ADMIN-PTG',
        'CTCH-UTILIZADOR-PTG',
        'CTCH-ADMINISTRADOR-PTG',
        'UNGE-SUPER ADMINISTRADOR-PTG'
    ])
    //Accept CCs
    can(['acceptCCs'], [
        'UNGE-UTILIZADOR',
        'UNGE-ADMINISTRADOR',
        'UNGE-INDISPS ADMIN',
        'UNGE-INDISPS UTLZ',
        'UNGE-SUPER ADMINISTRADOR'
    ])
    //Vista FCs
    can(['viewFCs'], [
        'UNGE-UTILIZADOR',
        'UNGE-ADMINISTRADOR',
        'UNGE-INDISPS ADMIN',
        'UNGE-INDISPS UTLZ',
        'UNGE-READER',
        'UNGE-SUPER ADMINISTRADOR'
    ])
    //Editar FCs
    can(['handleFCs'], [
        'UNGE-UTILIZADOR',
        'UNGE-ADMINISTRADOR',
        'UNGE-INDISPS ADMIN',
        'UNGE-INDISPS UTLZ',
        'UNGE-SUPER ADMINISTRADOR'
    ])
    //Redireccionar para FCs
    can(['redirectFCs'], [
        'UNGE-UTILIZADOR',
        'UNGE-ADMINISTRADOR',
        'UNGE-INDISPS ADMIN',
        'UNGE-INDISPS UTLZ',
        'UNGE-READER',
        'UNGE-SUPER ADMINISTRADOR'
    ])
    //Não redireccionar para FCs
    can(['!redirectFCs'], [
        'CTCH-UTILIZADOR',
        'CTCH-ADMINISTRADOR',
        'CTCH-READER',
        'SINES-UTILIZADOR',
        'SINES-ADMINISTRADOR',
        'SINES-READER',
        'RIBATEJO-UTILIZADOR',
        'RIBATEJO-ADMINISTRADOR',
        'RIBATEJO-READER',
        'LARES-UTILIZADOR',
        'LARES-ADMINISTRADOR',
        'LARES-READER',
        'EDPP_GLOBAL-READER'
    ])
    //Seleccionar país para Indisps e Conds
    can(['selectCountryIndispsConds'], [
        'CTCH-UTILIZADOR',
        'CTCH-ADMINISTRADOR',
        'UNGE-SUPER ADMINISTRADOR'
    ])
    //Row General PTG
    can(['viewGeneralPTG'], [
        'UNGE-UTILIZADOR',
        'UNGE-ADMINISTRADOR',
        'UNGE-INDISPS ADMIN',
        'UNGE-INDISPS UTLZ',
        'UNGE-READER',
        'CTCH-UTILIZADOR',
        'CTCH-ADMINISTRADOR',
        'CTCH-READER',
        'SINES-UTILIZADOR',
        'SINES-ADMINISTRADOR',
        'SINES-READER',
        'RIBATEJO-UTILIZADOR',
        'RIBATEJO-ADMINISTRADOR',
        'RIBATEJO-READER',
        'LARES-UTILIZADOR',
        'LARES-ADMINISTRADOR',
        'LARES-READER',
        'EDPP_GLOBAL-READER',
        'UNGE-SUPER ADMINISTRADOR'
    ])
    //Indisponilidades e Condicionamentos por tratar
    can(['viewToDoPTG'], [
        'UNGE-UTILIZADOR',
        'UNGE-ADMINISTRADOR',
        'UNGE-INDISPS ADMIN',
        'UNGE-INDISPS UTLZ',
        'UNGE-READER',
        'CTCH-UTILIZADOR',
        'CTCH-ADMINISTRADOR',
        'CTCH-READER',
        'SINES-UTILIZADOR',
        'SINES-ADMINISTRADOR',
        'SINES-READER',
        'RIBATEJO-UTILIZADOR',
        'RIBATEJO-ADMINISTRADOR',
        'LARES-UTILIZADOR',
        'LARES-ADMINISTRADOR',
        'EDPP_GLOBAL-READER',
        'UNGE-SUPER ADMINISTRADOR'
    ])
    //Indisponilidades e Condicionamentos visão global
    can(['viewCurrentIndCondPTG'], [
        'UNGE-UTILIZADOR',
        'UNGE-ADMINISTRADOR',
        'UNGE-INDISPS ADMIN',
        'UNGE-INDISPS UTLZ',
        'UNGE-READER',
        'UNGE-SUPER ADMINISTRADOR'
    ])
    //Indisponilidades e Condicionamentos em aberto PTG
    can(['viewAlertsIndispsPTG'], [
        'UNGE-UTILIZADOR',
        'UNGE-ADMINISTRADOR',
        'UNGE-INDISPS ADMIN',
        'UNGE-INDISPS UTLZ',
        'UNGE-READER',
        'UNGE-SUPER ADMINISTRADOR'
    ])
    //Alarmes PTG
    can(['viewAlarms'], [
        'UNGE-UTILIZADOR',
        'UNGE-ADMINISTRADOR',
        'UNGE-INDISPS ADMIN',
        'UNGE-INDISPS UTLZ',
        'CTCH-UTILIZADOR',
        'CTCH-ADMINISTRADOR',
        'SINES-UTILIZADOR',
        'SINES-ADMINISTRADOR',
        'RIBATEJO-UTILIZADOR',
        'RIBATEJO-ADMINISTRADOR',
        'LARES-UTILIZADOR',
        'LARES-ADMINISTRADOR',
        'UNGE-SUPER ADMINISTRADOR'
    ])
    //********************************************* */
    //Row Configs
    can(['viewConfigs'], [
        'UNGE-UTILIZADOR',
        'UNGE-ADMINISTRADOR',
        'UNGE-INDISPS ADMIN',
        'UNGE-INDISPS UTLZ',
        'UNGE-READER',
        'CTCH-UTILIZADOR',
        'CTCH-ADMINISTRADOR',
        'CTCH-READER',
        'SINES-UTILIZADOR',
        'SINES-ADMINISTRADOR',
        'SINES-READER',
        'RIBATEJO-UTILIZADOR',
        'RIBATEJO-ADMINISTRADOR',
        'RIBATEJO-READER',
        'LARES-UTILIZADOR',
        'LARES-ADMINISTRADOR',
        'LARES-READER',
        'EDPP_GLOBAL-READER',
        'PROD_HC-UTILIZADOR',
        'COM_HC-UTILIZADOR',
        'GDE_HC-UTILIZADOR',
        'GDE_HC-ADMINISTRADOR',
        'DGE_HC-UTILIZADOR',
        'GDE_ABO-UTILIZADOR',
        'UNGE-SUPER ADMINISTRADOR'
    ])
    //Vista Centrais
    can(['viewUnits'], [
        'UNGE-UTILIZADOR',
        'UNGE-ADMINISTRADOR',
        'UNGE-INDISPS ADMIN',
        'UNGE-INDISPS UTLZ',
        'UNGE-READER',
        'CTCH-UTILIZADOR',
        'CTCH-ADMINISTRADOR',
        'CTCH-READER',
        'SINES-UTILIZADOR',
        'SINES-ADMINISTRADOR',
        'SINES-READER',
        'RIBATEJO-UTILIZADOR',
        'RIBATEJO-ADMINISTRADOR',
        'RIBATEJO-READER',
        'LARES-UTILIZADOR',
        'LARES-ADMINISTRADOR',
        'LARES-READER',
        'EDPP_GLOBAL-READER',
        'PROD_HC-UTILIZADOR',
        'COM_HC-UTILIZADOR',
        'GDE_HC-UTILIZADOR',
        'GDE_HC-ADMINISTRADOR',
        'DGE_HC-UTILIZADOR',
        'GDE_ABO-UTILIZADOR',
        'UNGE-SUPER ADMINISTRADOR'
    ])
    //list of hydro units
    can(['viewUnitsHidro'], [
        'UNGE',
        'CTCH',
        'DGE_HC',
        'GDE_HC',
        'PROD_HC'
    ])
    //list of therm units
    can(['viewUnitsTerm'], [
        'UNGE',
        'SINES',
        'RIBATEJO',
        'LARES',
        'EDPP_GLOBAL',
        'DGE_HC',
        'GDE_HC',
        'PROD_HC',
        'COM_HC',
        'GDE_ABO'
    ])
    can(['viewRetail'], [
        'COM_HC'
    ])
    can(['viewThermal'], [
        'PROD_HC',
        'SINES',
        'RIBATEJO',
        'LARES',
    ])
    can(['viewThermalRetail'], [
        'UNGE',
        'EDPP_GLOBAL',
        'DGE_HC',
        'GDE_HC',
        'GDE_ABO'
    ])
    //Editar centrais
    can(['editUnits'], [
        'UNGE-ADMINISTRADOR',
        'UNGE-INDISPS ADMIN',
        'CTCH-ADMINISTRADOR',
        'GDE_HC-ADMINISTRADOR',
        'UNGE-SUPER ADMINISTRADOR'
    ])
    can(['!editUnits'], [
        'UNGE-UTILIZADOR',
        'UNGE-READER',
        'UNGE-INDISPS UTLZ',
        'CTCH-UTILIZADOR',
        'CTCH-READER'
    ])
    //Apagar centrais
    can(['createDeleteUnits'], [
        'UNGE-SUPER ADMINISTRADOR'
    ])
    //Vista Users
    can(['viewUsers'], [
        'UNGE-ADMINISTRADOR',
        'CTCH-ADMINISTRADOR',
        'SINES-ADMINISTRADOR',
        'RIBATEJO-ADMINISTRADOR',
        'LARES-ADMINISTRADOR',
        'UNGE-SUPER ADMINISTRADOR'
    ])
    //Criar, Editar e Apagar users
    can(['editUsers'], [
        'UNGE-SUPER ADMINISTRADOR'
    ])
    //Vista Regras
    can(['viewRules'], [
        'UNGE-SUPER ADMINISTRADOR'
    ])
//********************************************* */
    //Row Planes Mantenimiento
    can(['viewPlanesMantenimiento'], [
        'PROD_HC-UTILIZADOR',
        'COM_HC-UTILIZADOR',
        'GDE_HC-UTILIZADOR',
        'GDE_HC-ADMINISTRADOR',
        'DGE_HC-UTILIZADOR',
        'GDE_ABO-UTILIZADOR',
        'UNGE-ADMINISTRADOR',
        'UNGE-INDISPS ADMIN',
        'UNGE-READER',
        'UNGE-SUPER ADMINISTRADOR'
    ])
    //CPs
    //Vista CPs
    can(['viewCPs'], [
        'PROD_HC-UTILIZADOR',
        'COM_HC-UTILIZADOR',
        'GDE_HC-UTILIZADOR',
        'GDE_HC-ADMINISTRADOR',
        'DGE_HC-UTILIZADOR',
        'GDE_ABO-UTILIZADOR',
        'UNGE-ADMINISTRADOR',
        'UNGE-INDISPS ADMIN',
        'UNGE-READER',
        'UNGE-SUPER ADMINISTRADOR'
    ])
    //criar CPs como HC Production ou Comercial
    can(['createCPs'], [
        'PROD_HC-UTILIZADOR',
        'COM_HC-UTILIZADOR',
        'GDE_HC-UTILIZADOR',
        'GDE_HC-ADMINISTRADOR',
        'GDE_ABO-UTILIZADOR',
        'UNGE-SUPER ADMINISTRADOR'
    ])
    //manipular CPs como HC Production
    can(['handleCPsProd'], [
        'PROD_HC-UTILIZADOR',
        'COM_HC-UTILIZADOR',
        'UNGE-SUPER ADMINISTRADOR'
    ])
    //manipular CPs como HC Gestion
    can(['handleCPsGest'], [
        'GDE_HC-UTILIZADOR',
        'GDE_HC-ADMINISTRADOR',
        'GDE_ABO-UTILIZADOR',
        'UNGE-SUPER ADMINISTRADOR'
    ])
    //Vista FPs
    can(['viewFPs'], [
        'GDE_HC-UTILIZADOR',
        'GDE_HC-ADMINISTRADOR',
        'DGE_HC-UTILIZADOR',
        'GDE_ABO-UTILIZADOR',
        'UNGE-ADMINISTRADOR',
        'UNGE-INDISPS ADMIN',
        'UNGE-READER',
        'UNGE-SUPER ADMINISTRADOR'
    ])
    //manipular FPs
    can(['handleFPsGest'], [
        'GDE_HC-UTILIZADOR',
        'GDE_HC-ADMINISTRADOR',
        'GDE_ABO-UTILIZADOR',
        'UNGE-SUPER ADMINISTRADOR'
    ])
    //Vista PMs
    can(['viewPMs'], [
        'GDE_HC-UTILIZADOR',
        'GDE_HC-ADMINISTRADOR',
        'DGE_HC-UTILIZADOR',
        'GDE_ABO-UTILIZADOR',
        'UNGE-ADMINISTRADOR',
        'UNGE-INDISPS ADMIN',
        'UNGE-READER',
        'UNGE-SUPER ADMINISTRADOR'
    ])
    //********************************************* */
    //Row Indisps Sujeto
    can(['viewIndispsSujeto'], [
        'GDE_HC-UTILIZADOR',
        'GDE_HC-ADMINISTRADOR',
        'DGE_HC-UTILIZADOR',
        'GDE_ABO-UTILIZADOR',
        'UNGE-ADMINISTRADOR',
        'UNGE-INDISPS ADMIN',
        'UNGE-READER',
        'UNGE-SUPER ADMINISTRADOR'
    ])
    //Vista ISs
    can(['viewISs'], [
        'GDE_HC-UTILIZADOR',
        'GDE_HC-ADMINISTRADOR',
        'DGE_HC-UTILIZADOR',
        'GDE_ABO-UTILIZADOR',
        'UNGE-ADMINISTRADOR',
        'UNGE-INDISPS ADMIN',
        'UNGE-READER',
        'UNGE-SUPER ADMINISTRADOR'
    ])
    //manipular ISs
    can(['handleISsDesp'], [
        'GDE_HC-UTILIZADOR',
        'GDE_HC-ADMINISTRADOR',
        'GDE_ABO-UTILIZADOR',
        'DGE_HC-UTILIZADOR',
        'UNGE-SUPER ADMINISTRADOR'
    ])
    //Row General ESP
    can(['viewGeneralESP'], [
        'PROD_HC-UTILIZADOR',
        'COM_HC-UTILIZADOR',
        'GDE_HC-UTILIZADOR',
        'GDE_HC-ADMINISTRADOR',
        'DGE_HC-UTILIZADOR',
        'GDE_ABO-UTILIZADOR',
        'UNGE-SUPER ADMINISTRADOR'
    ])
    //To Do Espanha
    can(['viewToDoESP'], [
        'PROD_HC-UTILIZADOR',
        'COM_HC-UTILIZADOR',
        'GDE_HC-UTILIZADOR',
        'GDE_HC-ADMINISTRADOR',
        'DGE_HC-UTILIZADOR',
        'GDE_ABO-UTILIZADOR',
        'UNGE-SUPER ADMINISTRADOR'
    ])
    //VG ESP
    can(['viewCurrentIndCondESP'], [
        'GDE_HC-UTILIZADOR',
        'GDE_HC-ADMINISTRADOR',
        'GDE_ABO-UTILIZADOR',
        'UNGE-SUPER ADMINISTRADOR'
    ])  
    //********************************************* */
    can(['UMMUpdate'], [
        'update'
    ])
    can(['UMMResend'], [
        'resend'
    ])
})



// WEBPACK FOOTER //
// ./src/utils/ability.js